import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray, AbstractControl, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-dynamic-son-list-three-columns',
  templateUrl: './dynamic-son-list-three-columns.component.html',
  styleUrls: ['./dynamic-son-list-three-columns.component.scss']
})
export class DynamicSonListThreeColumnsComponent implements OnInit {
  @Input() parentForm: FormGroup;
  @Input() mySonListName: string;
  @Input() itemList;
  @Input() mylabel;
  @Input() captions: string[];
  @Input() view:boolean;
  counter = 0;
  sonList:FormArray;
  arrayWatcher;
  ownershipSum:number=0;

  constructor() { }

   ngOnInit() {
    this.ownershipSum=0; 
      
      this.addFlexListElement.value.map(element=>{
        this.ownershipSum+= element['Percentage'] as number;
        
      })
    this.addFlexListElement.valueChanges.subscribe(()=>{
      console.log(this.addFlexListElement.value);
      this.ownershipSum=0; 
      
      this.addFlexListElement.value.map(element=>{
        this.ownershipSum+= element['Percentage'] as number;
        
      })
    })
  }
  
  get addFlexListElement() {
    return this.parentForm.get(this.mySonListName) as FormArray
  }

  addItem(value?) {
    if (value) {
      let kk = new FormGroup({});
      kk.addControl(this.captions[0], new FormControl(value[0]));
      kk.addControl(this.captions[1], new FormControl(value[1]));
      kk.addControl(this.captions[2], new FormControl(value[2]));
     
      this.addFlexListElement.push(kk);
    }
    else {
      let kk = new FormGroup({});
      kk.addControl(this.captions[0], new FormControl(''));
      kk.addControl(this.captions[1], new FormControl(''));
      kk.addControl(this.captions[2], new FormControl(''));
     
      this.addFlexListElement.push(kk);
    }
  }

  removeItem(index:number) {
    this.addFlexListElement.removeAt(index);
}

}

